import Swiper from 'swiper';
import { Navigation } from 'swiper/modules'
import 'swiper/css';
import 'swiper/css/navigation';
Swiper.use([Navigation]);

class SHORT_VIDEO {
  videoWrapElm = document.querySelector('#video-wrap');
  videoElm = document.querySelector('#video');
  controls = ['play-large'];
  slideShort = document.querySelector('#slide-short');
  itemSiles = this.slideShort.querySelectorAll('.item');
  playPauseBtn = document.querySelector('.playPause')
  playBtn = this.playPauseBtn.querySelector('.play')
  pauseBtn = this.playPauseBtn.querySelector('.pause')
  muteBtn = document.querySelector('.mute')
  muteOn = document.querySelector('.on')
  muteOff = document.querySelector('.off')
  quitBtn = document.querySelector('.quit')
  nameElm = document.querySelector('.name')
  prevBtn = document.querySelector('.button-prev')
  nextBtn = document.querySelector('.button-next')
  constructor() {
    console.log('sfg', this.playPauseBtn)
    this.swiper();
  }

  swiper () {
    const swiper = new Swiper('#slide-short .swiper', {
      direction: 'vertical',
      loop: true,
      navigation: {
        nextEl: '.short-video-overlay .button-next',
        prevEl: '.short-video-overlay .button-prev',
      },

    });
    this.itemSiles[swiper.realIndex].classList.add('opacity-0');

    // init player video
    this.videoElm.muted ? this.muteBtn.classList.remove('active') : this.muteBtn.classList.add('active')
    this.videoElm.play();
    this.statusPlayer()

    //playPause click
    this.playPauseBtn.addEventListener('click', () => {
      this.videoElm.paused ? this.videoElm.play() : this.videoElm.pause()
      this.statusPlayer()
    })

    //mute click
    this.muteBtn.addEventListener('click', () => {
      this.videoElm.muted ? this.videoElm.muted = false : this.videoElm.muted = true
      this.videoElm.muted ? this.muteBtn.classList.remove('active') : this.muteBtn.classList.add('active')
    })

    //slide start
    swiper.on('sliderFirstMove', () => {
      console.log('sliderFirstMove');
      this.itemSiles.forEach(item => {
        if (item.classList.contains('opacity-0')) {
          item.classList.remove('opacity-0');
        }
      });
    });

    // slide change
    swiper.on('slideChange', () => {
      this.itemSiles[swiper.realIndex].classList.add('opacity-0');
      let link = this.itemSiles[swiper.realIndex].dataset['link'];
      this.videoElm.src = link
      this.videoElm.play()
      let name = this.itemSiles[swiper.realIndex].dataset['name'];
      let slug = this.itemSiles[swiper.realIndex].dataset['slug'];
      this.nameElm.textContent = name
      document.title = name
      window.history.pushState('page2', name, `${slug}.html`);


    });
    // slide short
    this.slideShort.addEventListener('click', (e) => {
        console.log(e.target);
        if (e.target.closest('.swiper-slide')) {
          this.playPauseBtn.click()
        } else {
          console.log(456, 'false');
        }
    })

    // this.prevBtn.addEventListener('click',() => {
    //   swiper.slidePrev()
    // })

    // this.nextBtn.addEventListener('click',() => {
    //   swiper.slideNext()
    // })
  }


  statusPlayer () {
    if (this.videoElm.paused) {
      this.pauseBtn.classList.add('hidden')
      this.pauseBtn.classList.remove('flex')
      this.playBtn.classList.remove('hidden')
      this.playBtn.classList.add('flex')
    } else {
      this.pauseBtn.classList.remove('hidden')
      this.pauseBtn.classList.add('flex')
      this.playBtn.classList.add('hidden')
      this.playBtn.classList.remove('flex')
    }
  }
}

export default window.addEventListener('DOMContentLoaded', evt => {
  new SHORT_VIDEO();
});
